import { IAddressEntity } from './address';
import { IEntityBase } from './entityBase';

export enum UserFaceIdStatus {
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED',
}

export enum UserAvatarStatus {
  EMPTY = 'EMPTY',
  VALID = 'VALID',
  INVALID = 'INVALID',
  NOT_VERIFIED = 'NOT_VERIFIED',
  UNAVAILABLE = 'UNAVAILABLE',
}

export enum UserGender {
  FEMALE = 'Feminino',
  MALE = 'Masculino',
  OTHER = 'Outros',
}

export type ForeignerUserDocumentType =
  | 'RNE'
  | 'PASSPORT'
  | 'DRIVERS_LICENSE'
  | 'OTHERS';

export enum FriendlyForeignerUserDocumentType {
  RNE = 'RNE',
  PASSPORT = 'Passaporte',
  DRIVERS_LICENSE = 'Carteira de motorista int.',
  OTHERS = 'Outros',
}

export interface IUserAddressBase extends IAddressEntity {
  userId: string;
}

export enum OnboardTypeLabel {
  'PENDING' = 'Pendente',
  'PARTIAL' = 'Parcial',
  'COMPLETED' = 'Completado',
}

export type OnboardType = 'PENDING' | 'PARTIAL' | 'COMPLETED';

export interface IUserAssignmentBase extends IEntityBase {
  bio?: string;
  blockedUntil?: string;
  isBlocked: boolean;
  hostId?: string;
  featureGroupId: string;
  userId: string;
  ventureId?: string;
}

export interface IUserOnboardBase extends IEntityBase {
  experience: number;
  onboardType: OnboardType;
  onboardingTerms: [];
  onboardingToken?: string;
  onboardingUrl?: string;
  userId: string;
  ventureId: string;
}

export interface IUserBase extends IEntityBase {
  avatar?: string;
  avatarUrl?: string;
  age?: number;
  birthDate?: string;
  confirmPending: boolean;
  cpf?: string;
  cnpj?: string;
  companyName?: string;
  email: string;
  gender?: UserGender;
  healthCheck?: string;
  name: string;
  foreignerDocument?: string;
  foreignerDocumentType?: ForeignerUserDocumentType;
  useForeignerDocument: boolean;
  paymentRegistered: boolean;
  phone?: string;
  tradeName?: string;
  avatarStatus: UserAvatarStatus;
  faceIdStatus: UserFaceIdStatus;
}
